import * as React from 'react';
import * as style from './SimplePagination.styl';
import * as classNames from 'classnames';

const DEFAULT_PAGE_SIZE = 20;

interface ISimplePaginationProps {
  page: number;
  pageSize?: number;
  count: number;
  zeroBased?: boolean; // If true, the component expects the "first" page to be 0, so it will add 1 to any page number before displaying it
  onPageChange: (page: number) => void;
}

const SimplePagination: React.FC<ISimplePaginationProps> = ({ page, count, onPageChange, pageSize = DEFAULT_PAGE_SIZE, zeroBased }) => {
  const totalPages = Math.ceil(count / pageSize);

  function updatePage(newPageNumber: number) {
    const adjustedNewPageNumberForValidation = zeroBased ? newPageNumber + 1 : newPageNumber;

    if (adjustedNewPageNumberForValidation >= 1 && adjustedNewPageNumberForValidation <= totalPages) {
      onPageChange(newPageNumber);
    }
  }

  if (count <= pageSize) {
    return null;
  }

  return (
    <>
      <div className={classNames('simple-pagination', style.global)}>
        <span data-testid="simple-pagination-prev" onClick={() => updatePage(page - 1)}>
          &larr;
        </span>
        <span data-testid="simple-pagination-start">{` ${zeroBased ? page + 1 : page}`} </span>/
        <span data-testid="simple-pagination-end"> {' ' + totalPages}</span>
        <span data-testid="simple-pagination-next" onClick={() => updatePage(page + 1)}>
          {' '}
          &rarr;
        </span>
      </div>
    </>
  );
};

export { SimplePagination, DEFAULT_PAGE_SIZE };
